// extracted by mini-css-extract-plugin
export default {"helpIconNoLabel":"helpIconNoLabel---leIqP","helpIcon":"helpIcon---jsMbR"};